import { useGLTF, useAnimations } from '@react-three/drei';
import { useLoader, useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { ObjectLoader, TextureLoader } from 'three';
import { d as defineSrc } from './index-CAxCDj_E.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'clsx';
import './common-DBpCdW70.esm.js';

const Jars = () => {
  const ref = useRef();
  const model = useGLTF(defineSrc('jars.glb'));
  const lights = useLoader(ObjectLoader, defineSrc('jars-light.json'));
  const wiseLogo = useLoader(TextureLoader, defineSrc('wise-flag-map-bump.jpg'));
  const jars = [];
  model.scene.traverse(child => {
    if (child.name.startsWith('Coin_')) {
      child.material.bumpMap = wiseLogo;
      child.material.bumpMap.flipY = false;
      child.castShadow = false;
      child.receiveShadow = false;
    }
    if (child.name.startsWith('Jar_')) {
      jars.push(child);
    }
  });
  const {
    mixer,
    clips
  } = useAnimations(model.animations, ref);
  useFrame(() => {
    mixer.clipAction(clips[0]).play();
    jars.forEach(jar => {
      jar.material.map.offset.x += 0.001;
      jar.material.map.offset.y += 0.0;
    });
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("primitive", {
      ref: ref,
      scale: 1.3,
      position: [0, -10, 0],
      object: model.scene
    }), /*#__PURE__*/jsx("primitive", {
      object: lights
    })]
  });
};

export { Jars as default };
//# sourceMappingURL=Jars-KgfjDdIn.esm.js.map
